import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/women-world-cup-personal-summary/img/标题.png'


const _withScopeId = n => (_pushScopeId("data-v-24cfaa5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "containerBack" }, null, -1))
const _hoisted_3 = { class: "players_wrapper" }
const _hoisted_4 = { class: "point-guard" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "guard" }
const _hoisted_7 = { class: "court-conatiner" }
const _hoisted_8 = { class: "players" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "head-pic" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "player-name" }
const _hoisted_13 = {
  class: /*#__PURE__*/_normalizeClass('name'),
  style: {"flex":"1","color":"#fbdda3ff"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, (position) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: position.title
        }, [
          _createElementVNode("div", _hoisted_4, [
            (position.title && position.title != 'undefined')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, _toDisplayString(position.title), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.data, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "player",
                  key: item.name,
                  onClick: ($event: any) => (_ctx.viewDetail(item))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      class: "img",
                      src: item.pic,
                      alt: ""
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.num), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass([_ctx.isLongName(item.name) ? 'longName' : '', 'name']),
                      style: {"flex":"3"}
                    }, _toDisplayString(item.name), 3)
                  ])
                ], 8, _hoisted_9))
              }), 128))
            ])
          ])
        ], 64))
      }), 128))
    ])
  ]))
}